<template>
	<div style="height:100%;">
		<div v-if="columnSettingsKey || $slots.toolbar" class="table-toolbar">
			<span class="table-toolbar-left">
				<slot name="toolbar"></slot>
			</span>
			<span v-if="columnSettingsKey" class="table-toolbar-right">
				<a-icon
					type="setting"
					class="table-column-settings-icon"
					@click="openColumnSettings"
				/>
			</span>
		</div>
		<a-table
			:ellipsis="true"
			:loading="loading"
			:row-selection="
				isSelect
					? {
						type: 'radio',
						selectedRowKeys: selectedRowKeys,
						selectedRows: selectedRows,
						onChange: onSelectChange,
				}
					: null
			"
			:columns="displayColumns"
			:customRender="customRender"
			:data-source="tableData"
			bordered
			:scroll="{ x: 100 }"
			:rowKey="(record, index) => index"
			size="small"
			:customRow="onClickRow"
			:pagination="pagination"
			v-bind:class="isActive ? 'table-area-active' : 'table-area-static'"
		>
			<template slot="orderStatus" slot-scope="scope">
				{{ scope.value }}
			</template>

			<template slot="isDeclaration" slot-scope="scope">
				<span v-if="scope!==null">{{ scope == true ? $t('yes') : $t('no') }}</span>
			</template>

			<template slot="trackStatus" slot-scope="scope, record">
				<span v-if="record.trackStatus">{{ record.trackStatus.msg }}</span>
			</template>

			<template slot="boundType" slot-scope="scope">
				{{ scope.msg }}
			</template>
			<template slot="receivableBoundType" slot-scope="scope">
				{{ scope.msg }}
			</template>
			<template slot="locationType" slot-scope="scope">
				{{ scope.value }}
			</template>
			<template slot="factoryAddress" slot-scope="scope, record">
				<span v-if="record.factoryAddress">
					<span
						v-for="(item, index) in record.factoryAddress.split(',')"
						:key="index"
						>{{ item }} <br />
					</span>
				</span>
			</template>
			<template slot="locationContactName" slot-scope="scope, record">
				<span v-if="record.locationContactName">
					<span
						v-for="(item, index) in record.locationContactName.split(',')"
						:key="index"
						>{{ item }} <br />
					</span>
				</span>
			</template>
			<template slot="locationContactPhone" slot-scope="scope, record">
				<span v-if="record.locationContactPhone">
					<span
						v-for="(item, index) in record.locationContactPhone.split(',')"
						:key="index"
						>{{ item }} <br />
					</span>
				</span>
			</template>

			<template slot="factoryContactName" slot-scope="scope, record">
				<span v-if="record.factoryContactName">
					<span
						v-for="(item, index) in record.factoryContactName.split(',')"
						:key="index"
						>{{ item }} <br />
					</span>
				</span>
			</template>

			<template slot="factoryContactPhone" slot-scope="scope, record">
				<span v-if="record.factoryContactPhone">
					<span
						v-for="(item, index) in record.factoryContactPhone.split(',')"
						:key="index"
						>{{ item }} <br />
					</span>
				</span>
			</template>

			<template slot="edit" slot-scope="scope, record">
				<slot name="option" v-bind:driver="record"> </slot>
			</template>
			<template slot="editLocation" slot-scope="scope, record">
				<slot name="option" v-bind:driver="record"> </slot>
			</template>
			<template slot="editCustomer" slot-scope="scope, record">
				<slot name="option" v-bind:driver="record"> </slot>
			</template>
			<template slot="updateTruck" slot-scope="scope, record">
				<slot name="option" v-bind:truck="record"></slot>
			</template>

			<template slot="seeAttachement" slot-scope="scope, record">
				<slot name="option" v-bind:attach="record"></slot>
			</template>

			<template slot="popover" slot-scope="scope, record">
				<a-tooltip
					:title="record.remark"
					placement="left"
					:getPopupContainer="(triggerNode) => triggerNode.parentNode"
					overlayClassName="popovername"
				>
					<span>{{ record ? record.remark : "" }}</span>
				</a-tooltip>
			</template>
		</a-table>
		<a-modal
			:visible="columnSettingsVisible"
			:title="$t('columnSettings.title')"
			:width="480"
			:mask-closable="false"
			:body-style="{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '16px' }"
			@cancel="closeColumnSettings"
		>
			<draggable
				:list="editingItems"
				:animation="150"
				item-key="key"
			>
				<div
					v-for="item in editingItems"
					:key="item.key"
					class="column-settings-row"
					:class="{ 'row-hidden': item.hidden }"
				>
					<a-checkbox
						:checked="!item.hidden"
						@change="(e) => onToggleColumn(item.key, e.target.checked)"
					>
						{{ item.title }}
					</a-checkbox>
				</div>
			</draggable>
			<template slot="footer">
				<a-button @click="closeColumnSettings">{{ $t('columnSettings.cancel') }}</a-button>
				<a-button type="primary" @click="saveColumnSettings">{{ $t('columnSettings.ok') }}</a-button>
			</template>
		</a-modal>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
import {
  getColumnSettings,
  setColumnSettings,
  mergeColumns
} from '@/utils/column-settings'

export default {
  name: "table-fixed",
  components: { draggable },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableColumn: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {};
      },
    },
    columnSettingsKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      isActive: true,
      columnSettingsVisible: false,
      editingItems: [],
      settingsVersion: 0,
    };
  },
  computed: {
    displayColumns() {
      // 依赖 settingsVersion 让缓存失效（修改设置后强制重算）
      // eslint-disable-next-line no-unused-vars
      const _v = this.settingsVersion
      const settings = getColumnSettings(this.columnSettingsKey)
      return mergeColumns(this.tableColumn, settings)
    },
  },
  watch: {
    tableData() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      // 通知父单元情况选择数据
      this.selectChanged([]);
    },
    loading: {
      handler() {
        this.isActive = !this.loading;
      },
    },
  },
  created() {},
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      this.selectChanged(selectedRows);
    },
    // 点击一行实现选中
    onClickRow(record, index) {
      return {
        on: {
          click: () => {
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.selectChanged(this.selectedRows);
          },
          dblclick: () => {
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.$emit("dbclickRow", this.selectedRows);
          },
          mouseenter: () => {
            this.rowClassName;
          }, // 鼠标移入行
        },
      };
    },
    // 通知父单元选择项发生变化
    selectChanged(selectedRows) {
      this.$emit("onSelectChange", selectedRows);
    },
    customRender() {
      // 保留原占位实现
    },
    buildEditingItems() {
      const settings = getColumnSettings(this.columnSettingsKey)
      const hiddenSet = new Set(settings.hidden)
      const order = settings.order && settings.order.length > 0
        ? settings.order
        : this.tableColumn.map(c => this.columnKeyOf(c))
      const keyToCol = new Map()
      this.tableColumn.forEach(c => {
        const k = this.columnKeyOf(c)
        if (k !== null) keyToCol.set(k, c)
      })
      const seen = new Set()
      const items = []
      order.forEach(k => {
        if (keyToCol.has(k) && !seen.has(k)) {
          seen.add(k)
          items.push({
            key: k,
            title: this.columnTitleOf(keyToCol.get(k)),
            hidden: hiddenSet.has(k),
          })
        }
      })
      this.tableColumn.forEach(c => {
        const k = this.columnKeyOf(c)
        if (k !== null && !seen.has(k)) {
          seen.add(k)
          items.push({
            key: k,
            title: this.columnTitleOf(c),
            hidden: hiddenSet.has(k),
          })
        }
      })
      return items
    },
    columnKeyOf(c) {
      if (c && typeof c.dataIndex === 'string' && c.dataIndex !== '') return c.dataIndex
      if (c && typeof c.title === 'string' && c.title !== '') return c.title
      return null
    },
    columnTitleOf(c) {
      if (!c) return ''
      if (typeof c.title === 'string') return c.title
      // title 也可能是 i18n key 或函数，回退到 dataIndex
      return c.dataIndex || ''
    },
    openColumnSettings() {
      this.editingItems = this.buildEditingItems()
      this.columnSettingsVisible = true
    },
    closeColumnSettings() {
      this.columnSettingsVisible = false
      this.editingItems = []
    },
    onToggleColumn(key, checked) {
      const item = this.editingItems.find(i => i.key === key)
      if (item) this.$set(item, 'hidden', !checked)
    },
    saveColumnSettings() {
      setColumnSettings(this.columnSettingsKey, {
        order: this.editingItems.map(i => i.key),
        hidden: this.editingItems.filter(i => i.hidden).map(i => i.key),
      })
      this.settingsVersion++
      this.columnSettingsVisible = false
      this.editingItems = []
    },
  },
};
</script>
<style scoped>
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.table-toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-toolbar-right {
  display: flex;
  align-items: center;
}
.table-column-settings-icon {
  font-size: 16px;
  cursor: pointer;
  color: #888;
}
.table-column-settings-icon:hover {
  color: #1890ff;
}
.column-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 4px;
  background: #fff;
  cursor: grab;
  user-select: none;
}
.column-settings-row:hover {
  border-color: #1890ff;
}
.column-settings-row:active {
  cursor: grabbing;
}
.column-settings-row.row-hidden {
  opacity: 0.5;
  background: #fafafa;
}
</style>
